import React from 'react';
import LanguageButtonDPC from "./dpc-language-button";
import LogoSVG from "../../img/logo-dpc-italia.svg";
import NavbarDPC from "./dpc-navbar";
import SubNavbarDPC from "./dpc-subnavbar";
import SvgIconDPC from "../dpc-svg-icon";
import {buildMenu} from "../../js/shared-functions";
import {navigate} from "@reach/router";
import GoogleAnalytics from './dpc-googleAnalytics';
import GoogleTagManager from './dpc-googleTagManager';

export default class DpcNavbar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {value: ''};
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }


    handleSubmit(event) {
        event.persist();
        event.preventDefault();
        const path = `/${this.props.lang}/risultati-ricerca/`;
        navigate(path, {
                state: {search: this.state.value},
                replace: false
            }
        )
        //this.setState({redirect: true})
    }

    handleInputChange(event) {
        event.persist();
        this.setState({value: event.target.value});
    }

    getMenu = (menuItems) => {
        return this.props.subdomain
            ? buildMenu(menuItems, this.props.lang, this.props.env, this.props.basePathNavbar, this.props.contenutoId, this.props.minisiti)
            : buildMenu(menuItems, this.props.lang, this.props.env, null, this.props.contenutoId, this.props.minisiti)
    };

    getHomePath = () => {
        if (this.props.subdomain) {
            return `${this.props.basePathNavbar}/${this.props.lang}/`
        } else {
            return `/${this.props.lang}/`
        }
    }

    getMinisitoUrl = () => {
        var subdomain = "";
        if(this.props.lang === 'it'){
            subdomain = this.props.subdomain;
        }else{
            subdomain = this.getLabel(this.props.subdomain);
        }
        return this.props.minisiti[`MINISITO_${subdomain.toUpperCase().replace(new RegExp("[\\s-]+", "g"), '_')}_URL`]
    }

    getLabel = (subdomain) => {
        switch(subdomain){
            case process.env.MINISITO_EMERGENZE_LABEL_EN:
                return process.env.MINISITO_EMERGENZE_LABEL;
            case process.env.MINISITO_RISCHI_LABEL_EN:
                return process.env.MINISITO_RISCHI_LABEL;
            case process.env.MINISITO_VOLONTARIATO_LABEL_EN:
                return process.env.MINISITO_VOLONTARIATO_LABEL;
            case process.env.MINISITO_DOMANDE_E_RISPOSTE_LABEL_EN:
                return process.env.MINISITO_DOMANDE_E_RISPOSTE_LABEL;
            case process.env.MINISITO_FORMAZIONE_LABEL_EN:
                return process.env.MINISITO_FORMAZIONE_LABEL;
            case process.env.MINISITO_MAPPE_LABEL_EN:
                return process.env.MINISITO_MAPPE_LABEL;
            case process.env.MINISITO_EVENTI_LABEL_EN:
                return process.env.MINISITO_EVENTI_LABEL;
            case process.env.MINISITO_RELAZIONI_INTERNAZIONALI_LABEL_EN:
                return process.env.MINISITO_RELAZIONI_INTERNAZIONALI_LABEL;
            case process.env.MINISITO_CAPRISCHIO_21_27_LABEL_EN:
                return process.env.MINISITO_CAPRISCHIO_21_27_LABEL;
            case process.env.MINISITO_SERVIZIO_NAZIONALE_LABEL_EN:
                return process.env.MINISITO_SERVIZIO_NAZIONALE_LABEL;
            case process.env.MINISITO_ATTUAZIONE_MISURE_PNRR_LABEL_EN:
                return process.env.MINISITO_ATTUAZIONE_MISURE_PNRR_LABEL;
            default:
                return "";

        }
    }

    render() {
        /*if(this.state.redirect){
            if(typeof window !== `undefined`){
                let url = this.props.basePathNavbar
                    ? new URL(this.props.basePathNavbar + '/risultati-ricerca')
                    : new URL(window.location.origin + `/${this.props.lang}/risultati_ricerca`);
                url.search = `search=${this.state.value}`;
                window.location.href = url;
            }
        }*/
        return (
            <header
                className={`it-header-wrapper it-header-sticky it-shadow ${this.props.classeAggiuntivaSubnavbar ? this.props.classeAggiuntivaSubnavbar : ""}`}
                role="banner"
                id={"header-dpc"}>
                <GoogleAnalytics trackingId="G-Q982JQHL8J" />
                <GoogleTagManager />
                <LanguageButtonDPC slugTraduzione={this.props.slugTraduzione} env={this.props.env}
                                   lang={this.props.lang}/>
                <div className="it-nav-wrapper">
                    <div className="it-header-center-wrapper">
                        <div className="container">
                            <div className="it-header-center-content-wrapper">
                                <div className="it-brand-wrapper">
                                    <ul className="list-inline">
                                        <li className="list-inline-item">
                                            <a href={this.getHomePath()}
                                               className="navbar-brand">
                                                <img src={LogoSVG} alt={"Logo del Dipartimento della Protezione Civile"}
                                                     className="brand-logo"/>
                                            </a>
                                        </li>
                                    </ul>
                                    <div>
                                        <h2>{this.props.lang === 'it' ?
                                            <a href={this.getHomePath()}
                                               title="Dipartimento della Protezione Civile">
                                                <span>Dipartimento</span> della Protezione Civile
                                            </a>
                                            :
                                            <a href={this.getHomePath()}
                                               title="Civil Protection Department">
                                                Civil Protection <span>Department</span>
                                            </a>
                                        }
                                        </h2>
                                        <h3>{this.props.lang === 'it' ? 'Presidenza del Consiglio dei Ministri' : 'Presidency  of the Council of Ministers'}</h3>
                                    </div>
                                </div>
                                <div className="it-right-zone">
                                    <div className="it-socials d-none d-xl-flex">
                                        <span>{this.props.lang === 'it' ? 'Seguici su' : 'Follow us'}</span>
                                        <ul>
                                            <li>
                                                <a href="https://www.facebook.com/DPCgov/"
                                                   title="Pagina Facebook del Dipartimento della Protezione Civile"
                                                   target="_blank" rel="noreferrer">
                                                    <SvgIconDPC name={'facebook'}/>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.instagram.com/dpcgov_official/"
                                                   title="Pagina Instagram del Dipartimento della Protezione Civile"
                                                   target="_blank" rel="noreferrer">
                                                    <SvgIconDPC name={'instagram'}/>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://twitter.com/dpcgov"
                                                   title="Segui il Dipartimento della Protezione Civile su Twitter"
                                                   target="_blank" rel="noreferrer">
                                                    <SvgIconDPC name={'twitter'}/>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.youtube.com/channel/UC4fru33Tzpu0UhCIHChiNFA"
                                                   title="Canale YouTube del Dipartimento della Protezione Civile"
                                                   target="_blank" rel="noreferrer">
                                                    <SvgIconDPC name={'youtube'}/>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.flickr.com/photos/141202146@N02/albums"
                                                   title="Profilo del Dipartimento della Protezione Civile su Flickr"
                                                   target="_blank" rel="noreferrer">
                                                    <SvgIconDPC name={'flickr'}/>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="it-search-wrapper">
                                        <span>{this.props.lang === 'it' ? 'Cerca' : 'Search'}</span>
                                        <a href="#" role="button" className="search-link-custom rounded-icon"
                                           title="Cerca"
                                           aria-haspopup="true" aria-expanded="false">
                                            <SvgIconDPC name={'search'}/>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="it-header-search-input-wrapper d-none">
                        <div className="container">
                            <div className="px-custom">
                                <form id="searchFormHeader" role="search" onSubmit={this.handleSubmit}>
                                    <div className="form-group">
                                        <div className="input-group">
                                            <label htmlFor="searchQueryHeader" className="sr-only active"
                                                   style={{transition: 'none 0s ease 0s', width: 'auto'}}>Inserisci
                                                parola
                                                chiave</label>
                                            <input type="text" className="form-control" id="searchQueryHeader"
                                                   name="searchQueryHeader" placeholder="Inserisci parola chiave"
                                                   onChange={this.handleInputChange} value={this.state.value}/>
                                            <div className="input-group-append">
                                                <button type="submit" id="searchSubmitHeader"
                                                        className="btn">{this.props.lang === 'it' ? 'Cerca' : 'Search'}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    {this.props.subdomain &&
                    <div className="is-subdomain-header-wrapper">
                        <div className="container">
                            <div className="px-custom">
                                <h3><a href={this.getMinisitoUrl() +'/'+ this.props.lang +'/'}>{this.props.subdomain}</a></h3>
                            </div>
                        </div>
                    </div>
                    }
                    <NavbarDPC menuItems={this.getMenu(this.props.menuItems)} lang={this.props.lang}/>
                    {(this.props.subdomain || !this.props.isHomepagePortale) &&
                    <SubNavbarDPC
                        menuItems={buildMenu(this.props.subdomainMenuItems, this.props.lang, this.props.env, null, this.props.contenutoId)}/>
                    }
                </div>
            </header>)
    }
};
